import React from 'react';
import { Input } from 'rsuite';

import './styles.css';
import { useCustomTheme } from '../../hooks/useCustomTheme';

/**
 * @typedef {import('rsuite').InputProps} InputProps
 * @typedef {Object} CustomProps
 * @property {JSX.Element} icon
 * @property {'left' | 'right'} iconPosition
 * @typedef {InputProps & CustomProps} Props
 */

/**
 * @component
 * @param {Props} props
 * @returns {JSX.Element}
 */

export function InputIcon({ icon = <></>, iconPosition = 'left', ...rest }) {
  const { theme } = useCustomTheme();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.colors.backgroundSecondary,
        borderRadius: 10,
        padding: '0px 10px',
      }}
    >
      {iconPosition === 'left' && icon}

      <Input {...rest} type="number" className="custom-input" />

      {iconPosition === 'right' && icon}
    </div>
  );
}
